export function contactReducer (state = {contact: [], error: null}, action) {
  switch (action.type) {
    case 'LOAD_CONTACT_START':
      return {
        ...state,
        error: null
      }
    case 'LOAD_CONTACT_SUCCESS':
      return {
        ...state,
        contact: action.payload
      }
    case 'LOAD_CONTACT_ERROR':
      return {
        ...state,
        error: action.payload,
        contact: []
      }
    default:
      return state;
  }
}

export default contactReducer;



// WEBPACK FOOTER //
// ./src/reducers/contact.js